import { useState } from 'react';

export default function useFocus(bool) {
    const [focus, setFocus] = useState(bool);
    function toggleError(bool, callback = false, e = '') {
        setFocus(bool);
        if (callback && typeof callback === 'function') {
            callback(e);
        }
    }
    return [focus, toggleError];
}
